import { createAsyncThunk } from "@reduxjs/toolkit";
import { getProfitLoss } from "../../api/admin/profit-loss.api";

/* ============================================================
   🔥 FETCH PROFIT & LOSS
============================================================ */
export const fetchProfitLoss = createAsyncThunk(
  "admin/profitLoss/fetch",
  async ({ tournament_id }, { rejectWithValue }) => {
    try {
      const res = await getProfitLoss({ tournament_id });

      if (!res.success) {
        return rejectWithValue(res.message);
      }

      return {
        data: res.data || [],
        summary: res.summary || {
          income: 0,
          expense: 0,
          profit: 0,
        },
      };

    } catch (error) {
      return rejectWithValue(error.message || "Fetch failed");
    }
  }
);